import { CSSProperties } from 'react';
import { TextAreaFormFieldComponent, TextFormFieldComponent } from '@vivli/shared/components';

const quarterRowStyle: CSSProperties = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
    columnGap: '10px',
};

const containerStyle: CSSProperties = {
    display: 'grid',
    gridAutoRows: 'auto',
    rowGap: '20px',
    paddingRight: '20px',
};

const twoColStyle: CSSProperties = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    columnGap: '10px',
};

export const StudyDetailsComponent = () => {
    return (
        <div style={containerStyle}>
            <TextAreaFormFieldComponent name={'studyTitle'} label={'Study Title'} rows={3} />
            <div style={twoColStyle}>
                <TextFormFieldComponent name={'sponsorProtocolId'} label={'Sponsor Protocol ID'} />
                <TextFormFieldComponent name={'nctId'} label={'NCT ID (e.g. NCT0001234)'} />
            </div>
            <div style={quarterRowStyle}>
                <TextFormFieldComponent name={'principalInvestigator.firstName'} label={'Principal Investigator First Name'} />
                <TextFormFieldComponent name={'principalInvestigator.lastName'} label={'Principal Investigator Last Name'} />
                <TextFormFieldComponent name={'principalInvestigator.emailAddress'} label={'Principal Investigator Email'} />
                <TextFormFieldComponent name={'principalInvestigator.orcidId'} label={'Principal Investigator ORCID iD'} />
            </div>
        </div>
    );
};
